const eventsHelper = {

	setEventListener(event: string, listener: Function) {
		window.document.addEventListener(event, (e: Event) => {
			const ce = e as CustomEvent;
			listener(ce.detail);
		});
	},

	dispatchEvent(event: string, data?: any) {
		let ce: CustomEvent;
		if (data) {
			ce = new CustomEvent(event, { detail: data });
		}
		else {
			ce = new CustomEvent(event);
		}
		
		window.document.dispatchEvent(ce);
	},

	removeEventListener(event: string, listener: any) {
		try {
			window.removeEventListener(event, listener);
		} catch(e) {
			console.error(`can't remove event listener ${event}`, e);
		}
	}
};

export default eventsHelper;